module.exports = __webpack_public_path__ + "img/jumpserver.416f7eca.png";